export default __webpack_public_path__ + "static/media/FuturaBookFont.ed19af44.ttf";